// src/components/analysis/detail/ElevatorPitchDetail.js
import React from 'react';
import { Box, Typography } from '@mui/material';

const ElevatorPitchDetail = ({ data }) => {
  return (
    <Box>
      <Typography variant="body1" paragraph>
        {data}
      </Typography>
    </Box>
  );
};

export default ElevatorPitchDetail;